module.exports = __webpack_public_path__ + "media/images/icon-meet-mobile-8df247d60dcce2f38abd2365cdab3c23.svg";